import { FeatureToggleClientService } from 'feature-toggle-client';
const activeMessagesScreen = 'active-message-screen';
const batchActiveMessage = 'batch-active-message';
const activeMessagesOnContactsJourney = 'active-messages-on-contacts-journey';
const activeMessageInternationalPhoneNumber = 'active-message-international-phone-number';
const newCampaignListingActive = 'new-campaingn-listing-active-message';
const showInProcessingActiveCampaignListing = 'is-to-show-in-processing-active-campaign-listing';
const showLanguagesForMessageTemplate = 'show-languages-for-message-template';
const newFlowAndIdListing = 'new-flow-and-id-listing-active-campaign';
const changesDisplayActiveCampaignData = 'changes-display-active-campaign-data';
const templatesLazyLoading = 'templates-lazy-loading-active-campaign';
const activeCampaignMfe = 'is-enabled-active-campaign-mfe';
const groupActiveMessage = 'group-active-message';
const marketingMessagesLiteApi = 'is-enabled-marketing-messages-lite-api';
const marketingMessagesLiteApiTagAlpha = 'show-marketing-messages-lite-api-tag-alpha';
const showWhatsAppGroupViewFeature = 'show-whats-app-group-view';
const isHideScheduler = 'is-hide-scheduler';
const isActiveMessagesMenuEnabled = 'is-active-message-menu-enabled';
const isSendMessageMenuEnabled = 'is-send-message-menu-enabled';
export class ActiveMessagesFeatures {
    static isToUseNewFlowAndIdListing() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(newFlowAndIdListing, false);
    }
    static isActiveMessageScreenEnabled() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(activeMessagesScreen, false);
    }
    static isHideScheduler() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(isHideScheduler, false);
    }
    static isBatchActiveMessageEnabled() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(batchActiveMessage, false);
    }
    static isActiveMessagesOnContactsJourneyEnabled() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(activeMessagesOnContactsJourney, false);
    }
    static isInternationalPhoneNumberActive() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(activeMessageInternationalPhoneNumber, false);
    }
    static isNewCampaignListingActive() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(newCampaignListingActive, this.newCampaignListingActiveDefaultValue);
    }
    static isToShowInProcessingActiveCampaignListing() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(showInProcessingActiveCampaignListing, this.showInProcessingActiveCampaignListingDefaultValue);
    }
    static isToShowLanguagesForMessageTemplate() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(showLanguagesForMessageTemplate, this.showLanguagesForMessageTemplateDefautValue);
    }
    static isChangesDisplayActiveCampaignData() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(changesDisplayActiveCampaignData, this.changesDisplayActiveCampaignDataDefaultValue);
    }
    static isTemplatesLazyLoading() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(templatesLazyLoading, this.templatesLazyLoadingDefaultValue);
    }
    static isEnabledActiveCampaignMFE() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(activeCampaignMfe, this.activeCampaignMfeDefaultValue);
    }
    static isGrouphActiveMessageEnabled() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(groupActiveMessage, false);
    }
    static isMarketingMessagesLiteApiEnabled() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(marketingMessagesLiteApi, this.marketingMessagesLiteApiDefaultValue);
    }
    static showMarketingMessagesLiteApiTagAlphaEnabled() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(marketingMessagesLiteApiTagAlpha, this.marketingMessagesLiteApiTagAlphaDefaultValue);
    }
    static async isShowWhatsAppGroupViewEnabled() {
        return await FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(showWhatsAppGroupViewFeature, this.showWhatsAppGroup);
    }
    static async isActiveMessageMenuEnabled() {
        return await FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(isActiveMessagesMenuEnabled, this.activeMessagesMenuEnabled);
    }
    static async isSendMessagesMenuEnabled() {
        return await FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(isSendMessageMenuEnabled, this.sendMessageMenuEnabled);
    }
}
ActiveMessagesFeatures.newCampaignListingActiveDefaultValue = false;
ActiveMessagesFeatures.showInProcessingActiveCampaignListingDefaultValue = false;
ActiveMessagesFeatures.showLanguagesForMessageTemplateDefautValue = false;
ActiveMessagesFeatures.activeCampaignAttendanceRedirectDefaultValue = false;
ActiveMessagesFeatures.changesDisplayActiveCampaignDataDefaultValue = false;
ActiveMessagesFeatures.activeCampaignMfeDefaultValue = false;
ActiveMessagesFeatures.templatesLazyLoadingDefaultValue = false;
ActiveMessagesFeatures.marketingMessagesLiteApiDefaultValue = false;
ActiveMessagesFeatures.marketingMessagesLiteApiTagAlphaDefaultValue = true;
ActiveMessagesFeatures.showWhatsAppGroup = false;
ActiveMessagesFeatures.activeMessagesMenuEnabled = false;
ActiveMessagesFeatures.sendMessageMenuEnabled = false;
